// extracted by mini-css-extract-plugin
export default {"wrap":"IconWithTooltip_wrap__428Vo"};